import { render, staticRenderFns } from "./BillingAddress.vue?vue&type=template&id=565af938&"
import script from "./BillingAddress.vue?vue&type=script&lang=ts&"
export * from "./BillingAddress.vue?vue&type=script&lang=ts&"
import style0 from "./BillingAddress.vue?vue&type=style&index=0&id=565af938&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports